module.exports = __webpack_public_path__ + "media/icons/check-red-162d0337.png";